import React from 'react';

import {useEventFamilies} from 'src/hooks/useEventFamilies';
import {EventReviewFeedback} from 'src/modules/ai';
import {HeaderFields} from 'src/modules/event-create/constants';
import {FAMILIES_INFO} from 'src/modules/event-create/event-create-hovers';
import {HeaderBlock} from 'src/modules/event-create/typedefs';
import {isEventFamiliesLoaded} from 'src/modules/event-families/services';
import {useAppSelector} from 'src/store';

import ComboBox, {ComboboxItem} from '@pb/kit-component-combo-box';
import {Dropdown} from '@pb/kit-component-dropdown-v2';
import {Group, Item} from '@pb/kit-component-group';
import {InfoIconButton} from '@pb/kit-component-icon-button';
import {Loading, Types} from '@pb/kit-component-loading';

type Props = {
    headerValues: HeaderBlock,
    changeRequestId: number | null,
    onChangeFamilies: (value: string[]) => void,
};

export const Families = (props: Props) => {
    const {headerValues, changeRequestId, onChangeFamilies} = props;
    const familiesList = useEventFamilies();
    const isFamiliesLoaded = useAppSelector(isEventFamiliesLoaded);

    return (
        <Group direction="v" gap="xxs" justify="space-between">
            <Group gap="xs" alignItems="center" justify="start">
                <strong>Families (optional):</strong>
                <Dropdown
                    hoverEnabled={true}
                    clickEnabled={false}
                    maxWidth={500}
                    anchor={({anchorRef, getAnchorProps}) => (
                        <InfoIconButton {...getAnchorProps()} ref={anchorRef}/>
                    )}>
                    {FAMILIES_INFO}
                </Dropdown>
                <EventReviewFeedback
                    changeRequestId={changeRequestId}
                    fieldName={HeaderFields.families}
                />
            </Group>
            <Group alignItems="center">
                <Item style={{width: '100%'}}>
                    <ComboBox
                        placeholder="Families Name"
                        value={headerValues.families}
                        onChange={onChangeFamilies}>
                        {familiesList.map(family => (
                            <ComboboxItem
                                key={family}
                                value={family}
                                caption={family}
                            />
                        ),
                        )}
                    </ComboBox>
                </Item>
                <Item style={{width: '1rem'}}>
                    {!isFamiliesLoaded && (
                        <Loading fast={true} type={Types.ICON}/>
                    )}
                </Item>
            </Group>
        </Group>
    );
};
